module.exports = __webpack_public_path__ + "static/img/status-no-lanes.fe826ac.png";